import { render } from "./AboutUsSectionComponent.vue?vue&type=template&id=3fc45e66&scoped=true"
import script from "./AboutUsSectionComponent.vue?vue&type=script&lang=js"
export * from "./AboutUsSectionComponent.vue?vue&type=script&lang=js"

import "./AboutUsSectionComponent.vue?vue&type=style&index=0&id=3fc45e66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc45e66"]])

export default __exports__